import React, { useContext } from 'react';
import { UtilsBlock, Breadcrumbs, BreadcrumbItem } from '@hz-design-system/web-ui';
import EnvironmentContext from '../../../contexts/EnvironmentContext';

const SellBreadcrumbs = () => {
  const { breadcrumbs } = useContext(EnvironmentContext);

  return (
    <UtilsBlock pb="l">
      <Breadcrumbs>
        {breadcrumbs.map(({ name, link }, index) => (
          <BreadcrumbItem
            icon={index === 0 ? 'home' : undefined}
            link={index === breadcrumbs.length - 1 ? '' : link}
            key={name}
            isCurrentPage={index === breadcrumbs.length - 1}
          >
            {name}
          </BreadcrumbItem>
        ))}
      </Breadcrumbs>
    </UtilsBlock>
  );
};

export default SellBreadcrumbs;
